module.exports = __webpack_public_path__ + "static/media/logo-veva.4ed82346.svg";